"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OperatorCircleLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var OperatorCircleLinear = function OperatorCircleLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 15c-5.523 0-10 4.477-10 10v3a3 3 0 00-3 3v4a3 3 0 003 3h3c.033 0 .067 0 .1-.002.08.559.206 1.112.38 1.651 2.974 9.253 16.066 9.253 19.04 0 .173-.539.3-1.09.38-1.649H41v.118a8 8 0 01-1.98 5.268l-1.273 1.456a1 1 0 001.506 1.316l1.273-1.455A10 10 0 0043 38.118V38a3 3 0 003-3v-4a3 3 0 00-3-3v-3c0-5.523-4.477-10-10-10h-6zm16 21a1 1 0 001-1v-4a1 1 0 00-1-1h-3v6h3zm-23-6v6h-3a1 1 0 01-1-1v-4a1 1 0 011-1h3zm2-4.285a34.712 34.712 0 0014.884 4.182l1.116.055v6.637a8 8 0 01-.384 2.448c-2.38 7.403-12.853 7.403-15.232 0A8 8 0 0122 36.59V25.715zm14.983 2.184l2.042.101H41v-3a8 8 0 00-8-8h-6a8 8 0 00-8 8v3h1v-2.998a1.581 1.581 0 012.366-1.373 32.714 32.714 0 0014.617 4.27z",
    fill: "url(#OperatorCircleLinear_svg__OperatorCircleLinear_svg__paint0_linear_17373_95651)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 30c0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30zm-2 0c0 15.464-12.536 28-28 28S2 45.464 2 30 14.536 2 30 2s28 12.536 28 28z",
    fill: "url(#OperatorCircleLinear_svg__OperatorCircleLinear_svg__paint1_linear_17373_95651)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "OperatorCircleLinear_svg__OperatorCircleLinear_svg__paint0_linear_17373_95651",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "OperatorCircleLinear_svg__OperatorCircleLinear_svg__paint1_linear_17373_95651",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  }))));
};

exports.OperatorCircleLinear = OperatorCircleLinear;
var _default = OperatorCircleLinear;
exports.default = _default;